export const COLUMNS = 'columns';
export const ROWS = 'rows';

export const viewTypes = [
  { value: ROWS, label: 'View by Rows' },
  { value: COLUMNS, label: 'View by Columns' },
];

export const detailAggregationTypes = [
  { value: 'ACCOUNT', label: 'Account' },
  { value: 'DEF_GRP', label: 'Deferred Group' },
  { value: 'ETR_GRP', label: 'ETR Group' },
];

export const groupTypeValues = {
  BUSINESSES: 'BZ',
  BUSINESS_UNITS: 'BU',
  COMPANY_CODES: 'CC',
  COUNTRY_CODES: 'CO',
  LEGAL_ENTITIES: 'LE',
  CUSTOM_GROUP: 'GR',
};

export const historicalGroupTypes = [
  { value: groupTypeValues.BUSINESSES, label: 'Businesses' },
  { value: groupTypeValues.BUSINESS_UNITS, label: 'Business Units' },
  { value: groupTypeValues.COMPANY_CODES, label: 'Company Codes' },
  { value: groupTypeValues.COUNTRY_CODES, label: 'Countries' },
  { value: groupTypeValues.LEGAL_ENTITIES, label: 'Legal Entities' },
];

export const groupTypes = [
  ...historicalGroupTypes,
  { value: groupTypeValues.CUSTOM_GROUP, label: 'Custom Group' },
];

export const groupTypeColumns = {
  BZ: 'BUSINESS_DESCRIPTION',
  BU: 'BUSINESS_UNIT',
  CC: 'COMPANY_CODE',
  CO: 'COUNTRY_CODE',
  LE: 'LEGAL_ENTITY',
  GR: 'COMPANY_CODE',
};

export const TOTAL_ROW = 'Total';
export const US_FEDERAL_TOTAL = 'US Federal Income Tax';

export const OPTION_ALL = { value: 'ALL', label: 'All' };

export const FUNC_CURRENCY_FIELD = 'FUNC_CURRENCY';
export const TAX_CURRENCY_FIELD = 'TAX_CURRENCY';

export const rowTypes = {
  COLUMN_HEADER: 'COLUMN_HEADER',
  TEXT: 'TEXT',
};

export const funcCurrencyFieldDescription = 'Currency';
export const taxCurrencyFieldDescription = 'Tax Currency';
export const defaultCurrency = 'USD';

export const specialReportLineTypes = {
  TOTAL_CREDITS: 'CREDIT',
  TOTAL_DEFERRED_CREDITS: 'DEF_CREDIT',
  STATE_ADJUSTMENT: 'STATE_CUR_TAX_ADJ',
};

export const ProvisionStatusNames = {
  IN_PROCESS: 'In Process',
  CALCULATED: 'Calculated',
  ERROR: 'Error',
};
